import React, { ReactElement } from 'react';
import { Button } from '@components';
import { getIn, useFormikContext } from 'formik';
import styles from './ReviewAccordionFooter.module.scss';

interface iReviewAccordionFooter {
  selectOptionName: string;
  closeOptionName: string;
  itemOption: string;
  validateFieldsNames: string[];
  isSelectButtonDisabled: boolean;
  isMultiSelect: boolean,
}
const ReviewAccordionFooter = ({ selectOptionName, closeOptionName, itemOption, validateFieldsNames, isSelectButtonDisabled, isMultiSelect }: iReviewAccordionFooter): ReactElement => {
  const formikContext = useFormikContext();
  const { values }: { values: any } = useFormikContext();

  const getButtonText = () => {
    if (isMultiSelect && getIn(values, selectOptionName).includes(itemOption)) {
      return 'Deselect this option';
    }
    return 'Select this option';
  };
  return (
    <div className={styles.buttonContainer}>
      <div className={styles.buttons}>
        <Button
          className={styles.backBtn}
          color="white"
          size="small"
          onClick={() => {
            formikContext.setFieldValue(closeOptionName, itemOption);
            formikContext.setFieldTouched(closeOptionName);
          }}
        >
          Close
        </Button>
        <Button
          className={styles.continueBtn}
          isDisabled={isSelectButtonDisabled}
          onClick={async () => {
            for (let index = 0, l = validateFieldsNames.length; index < l; index += 1) {
              formikContext.setFieldTouched(validateFieldsNames[index]);
              formikContext.validateField(validateFieldsNames[index]);
            }
            const errorMessages = Object.keys(formikContext.errors).filter((key) => validateFieldsNames.includes(key));
            if (errorMessages.length <= 0) {
              let selectedList = [];
              if (isMultiSelect) {
                selectedList = getIn(values, selectOptionName);
              }
              if (!isMultiSelect || !getIn(values, selectOptionName).includes(itemOption)) {
                selectedList.push(itemOption);
              } else if (getIn(values, selectOptionName).includes(itemOption)) {
                const indexToRemove = getIn(values, selectOptionName).indexOf(itemOption);
                getIn(values, selectOptionName).splice(indexToRemove, 1);
              }
              await formikContext.setFieldValue(selectOptionName, selectedList);
              await formikContext.setFieldTouched(selectOptionName);
              formikContext.setFieldValue(closeOptionName, itemOption);
            }
          }}
        >
          {getButtonText()}
        </Button>
      </div>
    </div>
  );
};

export default ReviewAccordionFooter;
